/** A customer paying more than the unit price would make the line owe a negative credit. */
export function refineCustomerPaidWithinPrice(value, context) {
    if (value.customerPaid > value.unitPrice) {
        context.addIssue({
            code: 'custom',
            message: 'Customer paid cannot be more than the unit price.',
            path: ['customerPaid'],
        });
    }
}
//# sourceMappingURL=refine-customer-paid-within-price.js.map